(function () {
    'use strict';

    angular
        .module('elogbooks.common.terms-of-use')
        .controller('TermsOfUseController', TermsOfUseController);

    TermsOfUseController.$inject = [
        '$state',
        'apiClient',
        'user',
        'userManager',
        'messenger',
        'confirmationModal',
        '$scope',
        '$rootScope'
    ];

    function TermsOfUseController(
        $state,
        apiClient,
        user,
        userManager,
        messenger,
        confirmationModal,
        $scope,
        $rootScope
    ) {
        var vm = this;
        $rootScope.feedbackRequired = false;
        vm.userNeedsAcceptTermsOfUse = userManager.userNeedsAcceptTermsOfUse();
        vm.loading = false;
        vm.locked = true;
        vm.accept = accept;
        vm.decline = decline;

        if (!vm.userNeedsAcceptTermsOfUse) {
            $state.go('dashboard.user.dashboard');
        }

        $scope.$on('$stateChangeStart', function(event) {
            if (
                vm.locked &&
                $state.current.name !== $state.next.name &&
                $state.next.name !== 'dashboard.terms-of-use' &&
                $state.next.name !== 'login.step1'
            ) {
                event.preventDefault();
                $state.go('dashboard.terms-of-use');
            }
        });

        function accept() {
            vm.loading = true;
            return apiClient.create(user.getLink('accept-terms-of-use')).then((response) => {
                if (response) {
                    vm.locked = false;
                    if (
                        user.shouldChangePassword
                    ) {
                        $state.go('dashboard.change-password', {}, {reload: true}).then(() => {
                            vm.loading = false;
                            messenger.success('TERMS_CONDITIONS_ACCEPTED');
                        });
                    } else {
                        $state.go('dashboard.user.dashboard', {}, {reload: true}).then(() => {
                            vm.loading = false;
                            messenger.success('TERMS_CONDITIONS_ACCEPTED');
                        });
                    }
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }

        function decline() {
            return confirmationModal.open(
                {
                    titleMessage: 'ARE_YOU_SURE_SHORT',
                    bodyMessage: 'YOU_NOT_BE_GRANTED_ACCESS_IF_YOU_DONT_ACCEPT',
                    primaryText: 'CONTINUE',
                    secondaryText: 'CANCEL'
                }
            ).result.then(() => {
                vm.loading = true;
                vm.locked = false;
                userManager.logout();
                $state.go('login.step1');
            });
        }
    }
})();
